import React from 'react';
import Navbar from '../components/Navbar';

const sections = [
  ['Dados coletados', 'Coletamos nome, e-mail, WhatsApp e informações de uso da plataforma. Para usuários Premium que enviam anúncios, coletamos também dados do veículo e fotos fornecidas pelo usuário.'],
  ['Uso dos dados', 'Os dados são utilizados para gerenciar a assinatura, controlar o acesso à plataforma, exibir anúncios aprovados e enviar comunicações relacionadas ao serviço.'],
  ['Compartilhamento', 'Dados de contato do vendedor (nome, WhatsApp, e-mail, cidade) são exibidos para assinantes ativos na página do veículo. Não vendemos dados a terceiros.'],
  ['Período de teste', 'Os dados de cartão fornecidos no cadastro do trial são processados exclusivamente pelo gateway de pagamento (Asaas). A Heritage não armazena dados de cartão.'],
  ['Segurança', 'Utilizamos criptografia e boas práticas de segurança para proteger seus dados. Senhas são armazenadas com hash seguro.'],
  ['Seus direitos', 'Você pode solicitar a exclusão ou correção dos seus dados a qualquer momento pelo e-mail de contato da Heritage.'],
];

export default function PoliticaPrivacidade() {
  return (
    <>
      <Navbar />
      <div style={{ background:'var(--cream)', minHeight:'calc(100vh - 112px)', padding:'64px 0' }}>
        <div className="container" style={{ maxWidth:760 }}>
          <div className="page-header">
            <div className="eyebrow">Legal</div>
            <h1 className="section-title">Política de privacidade</h1>
            <div className="gold-rule" />
          </div>
          <div style={{ fontSize:14, lineHeight:1.9, color:'var(--ink-mid)' }}>
            {sections.map(([titulo, texto], i) => (
              <div key={i} style={{ marginBottom:28 }}>
                <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:20, color:'var(--ink)', marginBottom:10 }}>{i+1}. {titulo}</h2>
                <p>{texto}</p>
              </div>
            ))}
            <p style={{ marginTop:40, fontSize:12, color:'var(--ink-muted)' }}>Última atualização: Janeiro de 2025</p>
          </div>
        </div>
      </div>
    </>
  );
}
